import './App.css';
import SignIn from './pages/signin/signin.js';
import SignUp from './pages/signup/signup.js';
import Dashboard from './pages/dashboard/dashboard';
import ResetPassword from './pages/resetpassword/resetPassword';
import Case from './pages/cases/case';
import { Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { Slide } from '@mui/material';
import Profile from './pages/profile/profile';
import NavigationScroll from './layout/NavigationScroll';
import appTheme from './components/apptheme';
import Amplify from 'aws-amplify';
import config from './aws-exports';
import ConfirmCode from './pages/signin/confirmcode';
import ChangePassword from './pages/resetpassword/changePassword';
import { useSelector } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import * as logoutAction from './actions/logoutAction';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as caseActions from './actions/caseActions';
import * as loginActions from './actions/loginActions';
import PhoneMessage from './pages/message/phonemessage';
import RequestView from './pages/requestview/requestview';

Amplify.configure({
  ...config,
  Analytics: {
    disabled: true
  }
});

function App() {
  const isLoggedIn = useSelector((state) => state.rootReducer.isLoggedIn);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const detectDeviceType = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ? 'Mobile'
      : 'Desktop';
  console.log(detectDeviceType()); // "Mobile" or "Desktop"

  // refresh to prompt on unsaved data
  window.onbeforeunload = function () {
    // save data or not
    dispatch(caseActions.setDataUpdated(false));
    // clear error
    dispatch(loginActions.clearError());
  };

  // close window will auto logout
  window.onunload = function () {
    //logout code here...
    //dispatch(logoutAction.logOut());
  };
  const onIdle = () => {
    // Close Modal Prompt
    // Do some idle action like log out your user
    if (isLoggedIn === true) {
      dispatch(logoutAction.logOut());
      navigate('/sop2web/signin');
    }
  };
  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 15,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    startOnMount: true,
    name: 'idle-timer'
  });
  return (
    <StyledEngineProvider injectFirst>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        TransitionComponent={Slide}>
        <ThemeProvider theme={appTheme}>
          <CssBaseline />
          <NavigationScroll>
            <Routes>
              {detectDeviceType() === 'Desktop' && <Route path="/sop2web/" element={<SignIn />} />}
              <Route path="/sop2web/signin" element={<SignIn />} />
              <Route path="/sop2web/signup" element={<SignUp />} />
              <Route path="/sop2web/resetpassword" element={<ResetPassword />} />
              {isLoggedIn === true && <Route path="/sop2web/home" element={<Dashboard />} />}
              {isLoggedIn === true && <Route path="/sop2web/newcase" element={<Case />} />}
              {isLoggedIn === true && (
                <Route path="/sop2web/requestview" element={<RequestView />} />
              )}
              {isLoggedIn === true && <Route path="/sop2web/profile" element={<Profile />} />}
              <Route path="/sop2web/confirmcode" element={<ConfirmCode />} />
              <Route path="/sop2web/changepassword" element={<ChangePassword />} />
              {detectDeviceType() === 'Mobile' && (
                <Route path="/sop2web/" element={<PhoneMessage />} />
              )}
              {/* <Route path="/sop2web/test" element={<PhoneMessage />} /> */}
              <Route path="*" element={<Navigate to="/sop2web/" />} />
            </Routes>
          </NavigationScroll>
        </ThemeProvider>
      </SnackbarProvider>
    </StyledEngineProvider>
  );
}

export default App;
